import { getSimpleISOString } from "@prismicio/editor-support/Date"
import { getRequestCredentials, request } from "@prismicio/editor-support/Http"
import { z } from "zod"

import { env } from "../env"
import { getRepositoryName } from "../routing"

const stringToBigInt = z.string().transform((value) => {
  try {
    return BigInt(value)
  } catch (error) {
    throw new Error(`Invalid BigInt string: ${value}`)
  }
})

type DailyUsage = z.infer<typeof DailyUsage>
const DailyUsage = z.object({
  date: z.string().date().pipe(z.coerce.date()),
  cloudFrontBandwidth: stringToBigInt,
  cloudFrontCalls: stringToBigInt,
  imgixBandwidth: stringToBigInt,
  imgixCalls: stringToBigInt,
})

type Usage = z.infer<typeof Usage>
const Usage = z.object({
  totalCloudFrontBandwidth: stringToBigInt,
  totalCloudFrontCalls: stringToBigInt,
  totalImgixBandwidth: stringToBigInt,
  totalImgixCalls: stringToBigInt,
  results: z.array(DailyUsage),
})

export interface GetUsageArgs {
  startDate: Date
  endDate: Date
}

export function getUsage(args: GetUsageArgs): Promise<Usage> {
  const { startDate, endDate } = args
  const url = new URL("usage/bandwidth", env.PRISMIC_USAGE_SERVICE_BASE_URL)
  url.searchParams.set("repository", getRepositoryName())
  url.searchParams.set("startDate", getSimpleISOString(startDate))
  url.searchParams.set("endDate", getSimpleISOString(endDate))

  return request(url, {
    credentials: getRequestCredentials(env.PRISMIC_PAGE_BUILDER_AUTH_STRATEGY),
    okType: Usage,
  })
}
